import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { AuthAction } from '../../actions/AuthAction';
import { RayForm, RayFormValidation } from '../../components/common';
import { EditSaveCancelBar } from '../../components/common/Buttons';
import { AppConfig, CountryCode } from '../../config';
import { LANG_SELECT_OPTIONS, normalizeLangCode } from '../../lib/preLoginLang';
import { AdminPosition } from '../../config/RayCodes';
import { AlertAction } from '../../actions';
import { Translate as t } from '../../config/Translate';
import { ROUTES } from '../../config/routes';
import { isAdminPathname } from '../../lib/isAdminPathname';
// import { S3Upload } from '../../components/common/FileUpload';

// 입력 초기값 규칙 한 곳 — 첫 렌더와 [취소](서버 값 복원)가 같이 쓴다.
const buildInputs = (user) => ({
    firstName: user?.firstName,
    lastName: user?.lastName,
    email: user?.email,
    hp: user?.hp,
    tel: user?.tel,
    language: user?.language,
    position: user?.position,
    companyInfo: {
        name: user?.companyInfo?.name,
        address: user?.companyInfo?.address,
        tel: user?.companyInfo?.tel,
        fax: user?.companyInfo?.fax,
        email: user?.companyInfo?.email,
    }
});

// editable·callback: 지금 호출처(MyInfo)는 넘기지 않음, 하위 호환용. editable 이 넘어오면 편집 상태를 제어(제어 모드).
const UserAccount = ({ user, editable, callback, UpdateUser, isUpdateRes, ClearUpdateResult, Logout, ErrorMsg }) => {

    const loc = useHistory();
    // const [t, i18n] = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [uploadDone, setUploadDone] = useState()
    const [countryName, setCountryName] = useState("");
    const [errors, setErrors] = useState([]);
    const isControlled = editable !== undefined;
    const [innerEditable, setInnerEditable] = useState(false);
    const isEditable = isControlled ? !!editable : innerEditable;
    const setIsEditable = (v) => { if (!isControlled) setInnerEditable(v); };
    const [err, setErr] = useState("")
    const avatarPastPath = "https://ray-data.s3.ap-northeast-2.amazonaws.com/";
    const [positionName, setPositionName] = useState("");

    const [inputs, setInputs] = useState(() => buildInputs(user));

    const form_controls = [
        {
            title: t('common.label.requiredInfo'), items: [
                { type: "input", name: "firstName", label: t('common.message.required.firstName'), val: inputs.firstName, required: true, isEditable: isEditable },
                { type: "input", name: "lastName", label: t('common.message.validation.lastNameRequired'), val: inputs.lastName, required: true, isEditable: isEditable },
            ], editinfo: true
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: inputs.email, required: true, isEditable: isEditable },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: inputs.hp, isEditable: isEditable },
                { type: "select", name: "country", label: t('common.field.country'), val: countryName, list: CountryCode },
                { type: "select", name: "position", label: t('common.field.position'), val: positionName, list: AdminPosition },
            ], editinfo: true
        },

        {
            title: t('common.label.optionalInfo'), items: [
                { type: "email", name: "companyInfo.email", label: t('common.field.email'), val: inputs.companyInfo.email },
            ], editinfo: false
        },
        {
            title: "", items: [
                { type: "input", name: "companyInfo.tel", label: t('common.field.tel'), val: inputs.companyInfo.tel },
                { type: "input", name: "companyInfo.fax", label: t('common.field.fax'), val: inputs.companyInfo.fax },
            ], editinfo: false
        },
        {
            title: "", items: [
                { type: "input", name: "companyInfo.address", label: t('common.field.fullAddress'), val: inputs.companyInfo.address, size: 12 },
            ], editinfo: false
        },
    ]

    useEffect(() => {
        const cName = CountryCode.filter((obj) => { return obj.code == user.companyInfo.country; });
        if (cName.length)
            setCountryName(cName[0].code);
        if (isUpdateRes) {
            setIsEditable(false);
            ClearUpdateResult();
        }

        const pName = AdminPosition.filter((obj) => { return obj.code == user.position; });
        if(pName.length)
            setPositionName(pName[0].code);

    }, [user]);

    function handleChangeData(e) {
        const { name, value } = e.target;
        setInputs(inputs => ({ ...inputs, [name]: value }));
    }

    const handleUpdateClick = async (e) => {
        e?.preventDefault?.();
        const errValidate = RayFormValidation(form_controls, inputs);
        if (errValidate.length > 0) {
            setErrors(errValidate);
        } else {
            setSubmitted(true);
            setErrors([]);
            // 저장 실패 시 편집을 닫지 않아 저장 안 된 값이 저장된 것처럼 보이지 않게 한다.
            let ok = false;
            try {
                ok = (await UpdateUser(inputs)) === true;
            } catch (err) {
                console.warn('[UserAccount] save failed', String(err?.message || err).slice(0, 200));
            }
            if (ok) {
                setIsEditable(false);
                callback?.();
            }
        }
    }

    const handleCancelClick = (e) => {
        setInputs(buildInputs(user));
        setErrors([]);
        setIsEditable(false);
        callback?.(e);
    }

    const uploadStart = (file) => {
        if (!file[0])
            return;
        const formData = new FormData()
        formData.append("file", file[0])
        formData.append("type", "normal");
        formData.append("acl", "public-read");
        formData.append("path", "avatar/");
      
        // S3Upload("avatar/", file[0]).then(res => {
        //     UpdateUser({ avatar: avatarPastPath + res.s3path });
        // });
        
        axios.post(AppConfig.API_SERVER_PATH + "/file/upload", formData, {
            headers: { "Content-Type": "multipart/form-data", "token": localStorage.getItem('userToken') },
            //onUploadProgress: data => {
            //	setProgress(Math.round((100 * data.loaded) / data.total))
            //}
        }).then(res => {
            if (res.data.status == "success") {
                UpdateUser({ avatar: avatarPastPath + res.data.data.path.s3path });
                //setUploadDone(res.data.data.path);
            } else if (res.message) {
                ErrorMsg("File upload failed");
            } else if (res.data.data.path.err) {
                ErrorMsg("File upload failed");
            }
        }).catch(() => {
            ErrorMsg("File upload failed");
        });
    }

    const hiddenFileInput = React.useRef(null);

    const handleChange = e => {
        uploadStart(e.target.files)
    };

    const handleClick = e => {
        hiddenFileInput.current.click();
    };

    return (
        <>
            <div className="section mt-4 mb-2 text-center">
                <div className="avatar-section">
                    <a onClick={(e) => handleClick(e)}>
                        {user.avatar && <img src={user.avatar} alt="avatar" className="imaged w100 rounded" />}
                        {!user.avatar && <img src="/assets/img/avatar_default_none.png" alt="avatar" className="imaged w100 rounded" />}
                        <span className="button">
                            <ion-icon name="camera-outline" role="img" className="md hydrated" aria-label="camera outline"></ion-icon>
                        </span>
                    </a>
                    <input type="file"
                        name={"file"}
                        ref={hiddenFileInput}
                        style={{ display: 'none' }}
                        onChange={e => uploadStart(e.target.files)} />
                </div>
            </div>
            <RayForm
                controls={isEditable ? form_controls.filter(c => c.editinfo) : form_controls}
                handleChangeData={handleChangeData}
                readOnly={!isEditable}
                errors={errors} />

            <div className="section mb-2">
                <EditSaveCancelBar
                    block
                    className="mt-2"
                    editing={isEditable}
                    onEdit={() => setIsEditable(true)}
                    onSave={handleUpdateClick}
                    onCancel={handleCancelClick}
                    saveLabelKey="common.button.update" />
                {!isEditable &&
                    <>
                        <Link className="btn btn-primary btn-block mt-1" to={isAdminPathname(window.location.pathname) ? ROUTES.ADMIN_UPDATE_PASSWORD : "/UpdatePassword"}>{t('auth.button.changePassword')}</Link>
                        <button className="btn btn-dark btn-block mt-1" onClick={() => Logout()}>{t('auth.button.signOut')}</button>
                    </>}
            </div>
        </>
    )
}

const mapState = state => {
    const user = AuthAction.getUserInfo(state);
    const isUpdateRes = state.AuthReducer.isUpdateRes;
    const languageName = LANG_SELECT_OPTIONS.find(o => o.code === normalizeLangCode(user?.language))?.title || '';
    return {
        user,
        isUpdateRes,
        languageName
    };
}

const mapDispatch = dispatch => ({
    UpdateUser: userInfo => dispatch(AuthAction.UpdateUser(userInfo)),
    Logout: () => dispatch(AuthAction.Logout()),
    ErrorMsg: (msg) => dispatch(AlertAction.ErrorMsg(msg)),
    ClearUpdateResult: () => dispatch(AuthAction.ClearUpdateResult())
})

export default connect(mapState, mapDispatch)(UserAccount);